import { Injectable } from '@angular/core';
import { AppUtilities } from './app.utilities';
import { Appkeys } from './app.keys';



@Injectable({ providedIn: 'root' })
export class AppInfoService {
  constructor() {}

  public get title() {
    return 'Genomic';
  }

  public get apiBaseUrl() {
    
    //return 'http://localhost:5000/api' //DEVVS
    //return 'https://localhost:5001/api' //DEVVSCODE

    //return 'https://apitestgeonomictech.ipidata.com/api'//UAT
    return 'https://api.geonomictech.com/api' //PROD
  }

  public get loginUserName() {
    return localStorage.getItem(Appkeys.CURRENT_USER);
  }

  public get modelUrl() {
    //return 'https://gviewtest.geonomictech.com';//UAT
    return 'https://gview.geonomictech.com';//PROD

  }

}
